import { CLEAR_STATE_OPK_NUMBERS, GET_OPK_NUMBERS_FAIL, SET_OPK_NUMBERS_LOADING, GET_OPK_NUMBERS,
    CLEAR_STATE_OPK_NUMBERS7, GET_OPK_NUMBERS7_FAIL, SET_OPK_NUMBERS7_LOADING, GET_OPK_NUMBERS7,
    CLEAR_STATE_OPK_NAMES, GET_OPK_NAMES_FAIL, SET_OPK_NAMES_LOADING, GET_OPK_NAMES,
    GET_OPK_NUMBERS_PROC, SET_OPK_NUMBERS_LOADING_PROC, GET_OPK_NUMBERS_FAIL_PROC, CLEAR_STATE_OPK_NUMBERS_PROC, 
    SET_OPK_NAMES_LOADING_PROC, GET_OPK_NAMES_FAIL_PROC, CLEAR_STATE_OPK_NAMES_PROC, GET_OPK_NAMES_PROC,
    CLEAR_STATE_OPK_FULL, GET_OPK_FULL_FAIL, SET_OPK_FULL_LOADING, GET_OPK_FULL } from '../actions/types'
const initialState = {
    OpkNumbers:null,
    OpkNumbersLoading: true,
    OpkNumbersError:null,
    OpkNumbers7:null,
    OpkNumbers7Loading: true,
    OpkNumbers7Error:null,
    OpkNames:null,
    OpkNamesLoading: true,
    OpkNamesError:null,
    OpkNumbersProc:null,
    OpkNumbersLoadingProc: true,
    OpkNumbersErrorProc:null,
    OpkNamesProc:null,
    OpkNamesLoadingProc: true,
    OpkNamesErrorProc:null,
    OpkFull:null,
    OpkFullError:null,
    OpkFullLoading:true
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_OPK_NUMBERS:
            return{
                ...state,
                OpkNumbers: action.payload,
                OpkNumbersLoading:false
            }
        case SET_OPK_NUMBERS_LOADING:
            return{
                ...state,
                OpkNumbersLoading:true
            }
        case GET_OPK_NUMBERS_FAIL:
            console.error(action.payload)
            return{
                ...state,
                OpkNumbersError:action.payload
            }
        case CLEAR_STATE_OPK_NUMBERS:
            return{
                ...state,
                OpkNumbers:null
            }
        case GET_OPK_NUMBERS7:
            return{
                ...state,
                OpkNumbers7: action.payload,
                OpkNumbers7Loading:false
            }
        case SET_OPK_NUMBERS7_LOADING:
            return{
                ...state,
                OpkNumbers7Loading:true
            }
        case GET_OPK_NUMBERS7_FAIL:
            console.error(action.payload)
            return{
                ...state,
                OpkNumbers7Error:action.payload
            }
        case CLEAR_STATE_OPK_NUMBERS7:
            return{
                ...state,
                OpkNumbers7:null
            }
        case GET_OPK_NAMES:
            return{
                ...state,
                OpkNames: action.payload,
                OpkNamesLoading:false
            }
        case SET_OPK_NAMES_LOADING:
            return{
                ...state,
                OpkNamesLoading:true
            }
        case GET_OPK_NAMES_FAIL:
            console.error(action.payload)
            return{
                ...state,
                OpkNamesError:action.payload
            }
        case CLEAR_STATE_OPK_NAMES:
            return{
                ...state,
                OpkNames:null
            }
        case GET_OPK_NUMBERS_PROC:
            return{
                ...state,
                OpkNumbersProc: action.payload,
                OpkNumbersLoadingProc:false
            }
        case SET_OPK_NUMBERS_LOADING_PROC:
            return{
                ...state,
                OpkNumbersLoadingProc:true
            }
        case GET_OPK_NUMBERS_FAIL_PROC:
            console.error(action.payload)
            return{
                ...state,
                OpkNumbersErrorProc:action.payload
            }
        case CLEAR_STATE_OPK_NUMBERS_PROC:
            return{
                ...state,
                OpkNumbersProc:null
            }
        case GET_OPK_NAMES_PROC:
            return{
                ...state,
                OpkNamesProc: action.payload,
                OpkNamesLoadingProc:false
            }
        case SET_OPK_NAMES_LOADING_PROC:
            return{
                ...state,
                OpkNamesLoadingProc:true
            }
        case GET_OPK_NAMES_FAIL_PROC:
            console.error(action.payload)
            return{
                ...state,
                OpkNamesErrorProc:action.payload
            }
        case CLEAR_STATE_OPK_NAMES_PROC:
            return{
                ...state,
                OpkNamesProc:null
            }
        case GET_OPK_FULL:
        return{
            ...state,
            OpkFull: action.payload,
            OpkFullLoading:false
        }
        case SET_OPK_FULL_LOADING:
            return{
                ...state,
                OpkFullLoading:true
            }
        case GET_OPK_FULL_FAIL:
            console.error(action.payload)
            return{
                ...state,
                OpkFullError:action.payload
            }
        case CLEAR_STATE_OPK_FULL:
            return{
                ...state,
                OpkFull:null
            }
        default:
            return state
        }
}